import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import DatePickercomp from "../../components/DatePicker";
import MyInput from "../../components/MyInput";
import { BsUpload } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  getAllBankListForDropdown,
  getSingleAccountDetailsById,
  postAccountDetails,
  updateAccountDetails,
} from "../../services/contractorApi";
import { addCreditor, updateCreditor } from "../../services/contractorApi";
import { ViewTransaction } from "../MasterDataManagement/AccountManagement/ViewTransaction";
import { getAdminAllHREmployees } from "../../services/authapi";
// import { bankToBankTransferSchema } from "../../utils/formSchema";
import { addCashVoucherSchema } from "../../utils/formSchema";

import CardComponent from "../../components/CardComponent";
import { getAllAccountDetails } from "../../services/contractorApi";
import { useSelector } from "react-redux";
import ConfirmAlert from "../../components/ConfirmAlert";
import { getAllPaymentModes } from "../../services/contractorApi";
import Select from "react-select";
import { addBankToBankTransfer } from "../../services/contractorApi";

import { getallbanktobankTransaction } from "../../services/authapi";
import { updateBankToBankTransfer } from "../../services/contractorApi";
import { useEffect, useState } from "react";
import { use } from "react";

import { onlyDecimalKey, handleDecimalPaste } from "../../utils/helper";
const AddCashVoucher = () => {
  const { id } = useParams();
  const isEditMode = !!id;
  const navigate = useNavigate();
  console.log("id", id);

  // const type = searchParams.get("type") || null;
  const type = "expl";
  const { t } = useTranslation();

  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [userAccount, setUserAccount] = useState([]);
  const [totalData, setTotalData] = useState(0);

  const [creditorsdata, setCreditorData] = useState([]);
  const [rows, setRows] = useState([]);

  const [paymentMode, setPaymentMode] = useState([]);
  const [edit, setEdit] = useState([]);
  const [fromHolderName, setFromHolderName] = useState("");
  const [toHolderName, setToHolderName] = useState("");
  const [firmBankAccount, setFirmBankAccount] = useState([]);
  const [amountError, setAmountError] = useState("");



  const user_type = useSelector((state) => state.auth.user.user_type);


  const transaction_type = [
    { value: "BU", label: "Cash Account → User " },
    { value: "BC", label: "Cash Account → Creditors " },

    { value: "UB", label: "User  → Cash Account " },
    { value: "CB", label: "Creditor → Cash Account" },
  ];

  // Apis -----------------

  const fetchAllHrEmployeesData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      forAccount: true,
      isDropdown: true,
    });
    if (res.status) {
      const data = res.data.filter(
        (item) =>
          item.account_number !== null &&
          item.bank_name !== null &&
          item.bank_name !== "" &&
          item.is_creditor == 0
      );
      setUserAccount(
        data.map((item) => {
          return {
            value: item.id,
            label: `${item.name} - ${item.bank_name} - ₹${item.closing_balance}`,
            account_number: item.account_number,
            closing_balance: item.closing_balance,
            fund_limit: item.fund_limit,
          };
        })
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setUserAccount([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const fetchAllBankData = async () => {
    const res = await getAllAccountDetails(
      search,
      pageSize,
      pageNo,
      user_id,
      user_type
    );
    setIsLoading(true);
    if (res.status) {
      setFirmBankAccount(
        // res.data.map((item) => {
        //   return {
        //     value: item.id,
        //     label: `${item.account_holder_name} - ${item.bank_name} - ₹${item.closing_balance}`,
        //     account_number: item.account_number,
        //     closing_balance: item.closing_balance,
        //   };
        // })
        res.data.filter((item) => item.bank_name === "Cash Account").map((item) => {
          return {
            value: item.id,
            label: `${item.account_holder_name} - ${item.bank_name} - ₹${item.closing_balance}`,
            account_number: item.account_number,
            closing_balance: item.closing_balance,
          };
        })
      );
      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };


  // creaditor api-----
  const fetchAllHrCrediotrsData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      forAccount: true,
      isCreditor: true,
    });
    if (res.status) {
      // const data = res.data.filter((item) => item.account_number);
      setCreditorData(
        res.data.map((item) => {
          return {
            value: item.id,
            label: `${item.name} - ${item.bank_name} - ₹${item.closing_balance}`,
            account_number: item.account_number,
            closing_balance: item.closing_balance,
          };
        })
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const user_id = useSelector((state) => state.auth.user.id);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log("values", values);
    if (!values) return [];

    const formData = new FormData();

    if (edit.account_id) {
      formData.append("transaction_type", values.transaction_type);
    }
    else {
      formData.append("cash_transaction_type", values.transaction_type);
    }

    formData.append("date", values.date);
    formData.append("amount", values.amount);
    formData.append("remark", values.remark || "");
    formData.append("transaction_id", values.transaction_id);
    formData.append("user_id", user_id);
    formData.append("transaction_for", values.transaction_for || "");

    if (values.from_account)
      formData.append("from_account", values.from_account);
    if (values.to_account) formData.append("to_account", values.to_account);
    if (values.payment_mode)
      formData.append("payment_mode", values.payment_mode);
    if (edit?.account_id && (values.transaction_type === "BU" || values.transaction_type === "BC")) {
      formData.append("account_transfer_id", id);
      // formData.append("creation_date", edit?.created_at);
    }
    if (edit?.id && (values.transaction_type === "UB" || values.transaction_type === "CB")) {
      formData.append("user_transfer_id", edit?.id);
    }


    try {
      const res =
        edit?.account_id || edit?.id
          ? await updateBankToBankTransfer(formData)
          : await addBankToBankTransfer(formData);


      if (res.status === true) {
        toast.success(res.message);
        navigate(-1);
        resetForm();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const fetchPaymentModes = async () => {
    const res = await getAllPaymentModes();
    if (res.status) {
      const rData = res.data.map((d) => {
        return { label: d.method, value: d.id };
      });

      setPaymentMode(rData);
    } else {
      setPaymentMode([]);
    }
  };

  const [searchParams] = useSearchParams();
  const isuser = searchParams.get("isuser") || null;

  const fetchallbankTransactions = async () => {
    const params = {
      "accounts_transfer_id": id,
    };
    const res = await getallbanktobankTransaction(params);
    if (res.status) {
      // const data = res.data.filter((item) => item.account_number);
      setEdit(res.data[0]);
      setFromHolderName(
        res.data[0].from_bank_account_number ||
        res.data[0].from_user_account_number
      );
      setToHolderName(
        res.data[0].to_user_account_number || res.data[0].to_bank_account_number
      );

      setTotalData(res?.pageDetails?.total);

    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };



  useEffect(() => {
    if (id == "new") {
      fetchPaymentModes();
      fetchAllHrEmployeesData();
      fetchAllBankData();
      fetchAllHrCrediotrsData();

    } else {
      fetchallbankTransactions();
      fetchPaymentModes();
      fetchAllHrEmployeesData();
      fetchAllBankData();
      fetchAllHrCrediotrsData();

    }

  }, [id, isuser]);
   const transactionFor = [
    { value: "F", label: " Fund" },
    { value: "S", label: " Stock" },
  ];

  return (
    <>
      <Helmet>
        <title>
          {id == "new" ? "Create New" : "Update "} Account · CMS Electricals
        </title>
      </Helmet>

      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <CardComponent
          showCardHeader={true}
          showBackButton={true}
          className={type === "details" && "after-bg-light"}
          title={`${type === "details"
            ? t("View")
            : (edit?.account_id !== undefined && edit?.account_id !== null) ||
              (edit?.id !== undefined && edit?.id !== null)
              ? t("Update")
              : t("Create ")
            } ${t("Cash Voucher")}`}
        >
          {/* <ViewTransaction  /> */}
          <Formik
            enableReinitialize={true}
            initialValues={{
              transaction_type: edit?.txn_category || "",
              from_account:
                edit?.txn_category === "BB" ||
                  edit?.txn_category === "BC" ||
                  edit?.txn_category === "BU"
                  ? firmBankAccount.find(
                    (opt) => opt.value === edit?.account_id
                  )?.value || ""
                  : edit?.txn_category === "UU"
                    ? userAccount.find(
                      (opt) => opt.value === edit?.from_user_id
                    )?.value || ""
                    : edit?.txn_category === "UB"
                      ? userAccount.find(
                        (opt) => opt.value === edit?.from_user_id
                      )?.value || ""
                      : edit?.txn_category === "CB"
                        ? creditorsdata.find(
                          (opt) => opt.value === (edit?.from_user_id || edit?.user_id)
                        )?.value || ""
                        : "",

              to_account: (() => {
                if (edit?.txn_category === "BB") {
                  return (
                    firmBankAccount?.find(
                      (opt) => opt.value == edit?.to_account_id
                    )?.value || ""
                  );
                }

                if (edit?.txn_category === "UU" || edit?.txn_category === "BU") {
                  return (
                    userAccount?.find(
                      (opt) => opt.value == (edit?.to_user_id || edit?.user_id)
                    )?.value || ""
                  );
                }

                if (edit?.txn_category === "BC") {
                  return (
                    creditorsdata?.find(
                      (opt) => opt.value == edit?.user_id
                    )?.value || ""
                  );
                }
                if (edit?.txn_category === "UB") {
                  return (
                    firmBankAccount?.find(
                      (opt) => opt.value == edit?.account_id
                    )?.value || ""
                  );
                }
                if (edit?.txn_category === "CB") {
                  return (
                    firmBankAccount?.find(
                      (opt) => opt.value == edit?.account_id
                    )?.value || ""
                  );
                }

                return "";
              })(),
              // from_account: edit?.user_id || "",
              date: edit?.bank_txn_date || new Date().toISOString().slice(0, 10),
              amount: edit?.bank_amount || "",
              transaction_id: edit?.bank_txn_id || "",
              payment_mode: "1",
              remark: edit?.remark || "",
              transaction_for: edit?.transaction_category === "Fund"
                ? "F"
                : edit?.transaction_category === "Stock"
                  ? "S"
                  : "",
            }}
            validationSchema={addCashVoucherSchema}
            onSubmit={handleSubmit}
          >
            {(props) => (
              <Form onSubmit={props.handleSubmit}>
                <Row className="g-3">
                  {/* Transaction Type */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Transaction Type <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="transaction_type"
                      formikProps={props}
                      customType="select"
                      className="cursor-pointer"
                      selectProps={{ data: transaction_type }}
                      isDisabled={edit?.id ? true : false}
                      onChange={(option) => {
                        const value = option?.value || "";
                        // props.setFieldValue("transaction_type", value || "")
                        setAmountError("");
                        props.setFieldValue("transaction_type", value);
                        props.setFieldValue("from_account", "");
                        props.setFieldValue("to_account", "");

                        if (value === "BU") {
                          fetchAllHrEmployeesData();
                          props.setFieldValue("from_account", firmBankAccount[0].value);
                        }
                        if (value === "BC") {
                          fetchAllHrCrediotrsData();
                          props.setFieldValue("from_account", firmBankAccount[0].value);
                        }
                        if (value === "UU") {
                          fetchAllHrEmployeesData();
                        }
                        if (value === "UB") {
                          fetchAllHrEmployeesData();
                          props.setFieldValue("to_account", firmBankAccount[0].value);

                        }
                        if (value === "CB") {
                          fetchAllHrCrediotrsData();
                          props.setFieldValue("to_account", firmBankAccount[0].value);
                        }

                      }}
                    />
                  </Form.Group>

                  {/* From Account Field */}

                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      {t(
                        `From ${props.values.transaction_type == "UU" ||
                          props.values.transaction_type === "UB"
                          ? "User Account"
                          : props.values.transaction_type == "CB"
                            ? "Creditors Account"
                            : "Cash Account"
                        } `
                      )}

                      <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="from_account"
                      formikProps={props}
                      customType="select"
                      // isDisabled={""}
                      selectProps={{
                        data:
                          props?.values?.transaction_type === "UB"
                            ? userAccount
                            : props?.values?.transaction_type === "CB"
                              ? creditorsdata
                              : props?.values?.transaction_type === "UU"
                                ? userAccount
                                : (props?.values?.transaction_type === "BU" || props?.values?.transaction_type === "BC") ? firmBankAccount
                                  : [],
                      }}
                      onChange={(option) => {
                        const value = option?.value || "";
                        props.setFieldValue("from_account", value);
                      }}
                      isDisabled={props.values.transaction_type === "BC" || props.values.transaction_type === "BU" || edit?.id}
                    />
                  </Form.Group>


                  {/* To Account Field */}

                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      {t(
                        `To ${props.values.transaction_type == "UU" ||
                          props.values.transaction_type === "BU"
                          ? "User Account"
                          : props.values.transaction_type == "BC"
                            ? "Creditors Account"
                            : " Cash Account"
                        } `
                      )}

                      <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="to_account"
                      formikProps={props}
                      customType="select"
                      // isDisabled={""}
                      selectProps={{
                        data:
                          props?.values?.transaction_type === "BU"
                            ? userAccount
                            : props?.values?.transaction_type === "BC"
                              ? creditorsdata
                              : props?.values?.transaction_type === "UU"
                                ? userAccount.filter(
                                  (user) =>
                                    user.value !== props.values.from_account
                                )
                                : props?.values?.transaction_type === "UB" ? firmBankAccount : props?.values?.transaction_type === "CB" ? firmBankAccount : [],
                      }}
                      onChange={(option) => {
                        const value = option?.value || "";
                        props.setFieldValue("to_account", value);
                      }}
                      isDisabled={props.values.transaction_type === "CB" || props.values.transaction_type === "UB"}
                    />
                  </Form.Group>


                  {/* Auto Filled From Holder */}
                  {/* <Form.Group as={Col} md={4}>
                          <Form.Label>From Account Holder Number</Form.Label>
                          <Form.Control
                            name="from_account_holder_number"
                            isDisabled={""}
                            type="text"
                            value={""}
                            readOnly
                            placeholder="Account Number"
                          />
                        </Form.Group> */}

                  {/* Auto Filled To Holder */}
                  {/* <Form.Group as={Col} md={4}>
                          <Form.Label>To Account Holder Number</Form.Label>
                          <Form.Control
                            name="to_account_holder_number"
                            type="text"
                            value={""}
                            isDisabled={""}
                            readOnly
                            placeholder=" Account Number"
                            onChange={""}
                          />
                        </Form.Group> */}

                  {/* Date */}

  {(props.values.transaction_type == "BU"  ) && (
                      <Form.Group as={Col} md={4}>
                        <Form.Label>
                          Transaction for <span>*</span>{" "}
                        </Form.Label>
                        <MyInput
                          name="transaction_for"
                          formikProps={props}
                          disabled={edit?.id}
                          customType="select"
                          selectProps={{ data: transactionFor }}
                          onChange={(option) => {
                            props.setFieldValue(
                              "transaction_for",
                              option?.value || ""
                            );
                            console.log(
                              "Transaction for changed to",
                              option?.value
                            );
                          }}
                        />
                      </Form.Group>
                    )}

                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Transaction Date <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePickercomp
                      name="date"
                      value={props.values.date}
                      sendDate={(date) => props.setFieldValue("date", date)}
                      isDisabled={edit?.id}
                    // isDisabled={""}
                    // onChange={""}
                    />
                  </Form.Group>

                  {/* Amount */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Transfer Amount <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="amount"
                      type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                      placeholder="Enter Amount"
                      formikProps={props}
                      onChange={(e) => {
                        props.setFieldValue("amount", e.target.value);
const txnType = props.values.transaction_type;
const fromAccount = props.values.from_account;
const amount = Number(e.target.value);

// Decide which account list to check from
const isFirmTxn = ["BB", "BC", "BU"].includes(txnType);

let accountList;

if (["BU", "BC"].includes(props.values.transaction_type)) {
  accountList = firmBankAccount;
} else if (props.values.transaction_type === "UB") {
  accountList = userAccount;
} else if (props.values.transaction_type === "CB") {
  accountList = creditorsdata;
}


  const accountDetails = accountList?.find((item) => item.value === fromAccount);
const closing_balance = accountDetails?.closing_balance || 0;

// Step 1: Validate closing balance
if (amount > closing_balance) {
  setAmountError("Amount is greater than bank balance");
} else {
  setAmountError("");
}

// Step 2: Extra fund-limit check *only for BU*
if (txnType === "BU") {
  const fund_limit = userAccount.find(
    (acc) => acc.value === props.values.to_account
  )?.fund_limit || 0;
  const user_closing_balance = userAccount.find(
    (acc) => acc.value === props.values.to_account
  )?.closing_balance || 0;
  const available_limit = fund_limit - user_closing_balance;

  if (amount > available_limit) {
    setAmountError(
      `Amount exceeds Available fund limit of ₹${available_limit} and remaining limit is ₹${available_limit - amount}`
    );
  } else {
    setAmountError("");
  }
}

                      }}
                    />
                    {amountError && (
                      <Form.Text className="text-danger">
                        {amountError}
                      </Form.Text>
                    )}
                  </Form.Group>


                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Transaction Id
                    </Form.Label>
                    <MyInput
                      name="transaction_id"
                      type="text"
                      placeholder="Enter Transaction Id"
                      formikProps={props}
                      onChange={(e) =>
                        props.setFieldValue("transaction_id", e.target.value)
                      }
                    />
                  </Form.Group>
                  <Form.Group as={Col} md={4}>
                    <Form.Label>Payment Mode </Form.Label>
                    <MyInput
                      name="payment_mode"
                      formikProps={props}
                      customType="select"

                      selectProps={{
                        data: paymentMode,
                      }}
                      onChange={(option) => {
                        props.setFieldValue(
                          "payment_mode",
                          option?.value || ""
                        );
                      }}
                      isDisabled={true}
                    />
                  </Form.Group>

                  {/* Remark */}
                  <Form.Group as={Col} md={14}>
                    <Form.Label>Remark / Narration</Form.Label>
                    <MyInput
                      name="remark"
                      customType="multiline"
                      placeholder="Enter Remark"
                      formikProps={props}
                      onChange={(e) =>
                        props.setFieldValue("remark", e.target.value)
                      }
                    />
                  </Form.Group>

                  {/* Attachment */}

                  {/* Submit */}
                  <Form.Group as={Col} md={12}>
                    <div className="mt-4 text-center">
                      <button
                        type={"submit"}
                        // onClick={""}
                        // disabled={""}
                        disabled={props?.isSubmitting || !!amountError}
                        className="shadow border-0 purple-combo cursor-pointer px-4 py-1"
                      >
                        Submit
                        {/* <Spinner
                                animation="border"
                                variant="primary"
                                size="sm" /> */}
                      </button>

                      <ConfirmAlert
                        size={"sm"}
                        deleteFunction={props.handleSubmit}
                        hide={""}
                        show={""}
                        title={"Confirm UPDATE"}
                        description={"Are you sure you want to update this!!"}
                      />
                    </div>
                  </Form.Group>
                </Row>
              </Form>
            )}
          </Formik>
        </CardComponent>
      </Col>
    </>
  );
};

export default AddCashVoucher;
